import React, { forwardRef } from 'react';
import { cloneElement } from 'react';
import { useFormContext, UseFormRegisterReturn } from 'react-hook-form';

type FormFieldProps = {
  name: string;
  children:
    | React.ReactNode
    | ((field: UseFormRegisterReturn & { error?: string }) => React.ReactNode);
};

// Define as a proper named component first
export const FormField: React.FC<FormFieldProps> = forwardRef((props, ref) => {
  const { name, children } = props;
  // Use useFormContext instead of useForm to access the parent form
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const field = register(name);
  const errorMessage = errors[name]?.message?.toString();

  return typeof children === 'function'
    ? children({ ...field, error: errorMessage })
    : cloneElement(children as React.ReactElement, { ...field, error: errorMessage, ref });
});
